<style media="screen">

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }

    .avatar-uploader-icon {
        padding-top: 71px;
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    input[type=file] {
        display: none;
    }

</style>

<template>

    <el-row>
        <el-form :model="bannerForm" :rules="rules" addAction="news/addNews.action" editAction="news/editNews.action"
                 label-width="100px" ref="bannerForm" selectAction="news/getNews.action" v-form>

            <h3>
                新增发布
            </h3>
            <el-col :span="18" class="basic-margin">

                  <el-form-item label="选择广告位" label-position="left" prop="target">
                    <!-- <el-radio-group v-model="bannerForm.target">
                        <el-radio :label="1">首页顶部banner</el-radio>
                        <el-radio :label="5">首页中部banner</el-radio>
                        <el-radio :label="4">首页活动专区</el-radio>
                        <el-radio :label="6">本地资讯</el-radio>
                    </el-radio-group> -->

                    <el-radio-group v-if="targetDbtResult == 1" v-model="bannerForm.target">
                      <el-tooltip class="item" effect="dark" content="首页展示所有已上架的广告" placement="top"><el-radio label="13">首页banner
                        <p style="font-size:11px;">(750*320px)</p>
                      </el-radio> </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="活动专区广告位不限，展示所有已上架的广告" placement="top"> <el-radio label="4">活动专区
                            <p style="font-size:11px;">
                                (750*320px)</p>
                        </el-radio></el-tooltip>
                      <el-tooltip class="item" effect="dark" content="本地资讯发布不限，展示所有已上架的资讯" placement="top">  <el-radio label="6">本地资讯
                        <p style="font-size:11px;">(750*480px)</p>
                      </el-radio></el-tooltip>
                        <el-tooltip class="item" effect="dark" content="资讯流广告位1个，展示已上架的前1条广告" placement="top"> <el-radio label="7">资讯流广告
                            <p style="font-size:11px;">
                                (750*320px)</p>
                        </el-radio></el-tooltip>
                        <el-tooltip class="item" effect="dark" content="商家页顶部banner广告位5个，展示已上架的前5条广告" placement="top"><el-radio label="9">商家页顶部banner
                            <p style="font-size:11px;">
                                (750*320px)</p>
                       </el-radio> </el-tooltip>
                        <!--                  <el-radio label="10">资讯页顶部banner<p style="font-size:11px;">(750*320px)</p></el-radio>-->
                        <el-tooltip class="item" effect="dark" content="首页弹窗广告位1个，展示已上架的前1条弹窗广告（每天对同一个用户只展示1次，关闭弹窗广告请删除）" placement="top">  <el-radio label="8">首页弹窗广告
                                <p style="font-size:11px;">
                                    (640*808px)</p>
                            </el-radio>  </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="小程序首页顶部banner广告位10个，展示已上架的前10条广告" placement="top">  <el-radio label="11">小程序首页顶部banner
                            <p style="font-size:11px;">
                                (750*320px)</p>
                        </el-radio> </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="小程序活动专区广告位不限，展示所有已上架的广告" placement="top"> <el-radio label="12">小程序活动专区
                            <p style="font-size:11px;">
                                (750*320px)</p>
                        </el-radio></el-tooltip>

                    </el-radio-group>

                      <el-radio-group v-if="targetDbtResult == 2" v-model="bannerForm.target">

                        <el-tooltip class="item" effect="dark" content="首页展示所有已上架的广告" placement="top"><el-radio label="13">首页banner
                          <p style="font-size:11px;">(750*320px)</p>
                        </el-radio> </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="首页弹窗广告位1个，展示已上架的前1条弹窗广告（每天对同一个用户只展示1次，关闭弹窗广告请删除）" placement="top">  <el-radio label="8">首页弹窗广告
                          <p style="font-size:11px;">(750*1000px)</p>
                        </el-radio>  </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="本地资讯发布不限，展示所有已上架的资讯" placement="top">  <el-radio label="6">本地资讯
                          <p style="font-size:11px;">(750*480px)</p>
                        </el-radio></el-tooltip>
                      </el-radio-group>

                      <el-radio-group v-if="targetDbtResult == 3" v-model="bannerForm.target">

                        <el-tooltip class="item" effect="dark" content="首页展示所有已上架的广告" placement="top"><el-radio label="13">首页banner
                          <p style="font-size:11px;">(750*320px)</p>
                        </el-radio> </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="首页弹窗广告位1个，展示已上架的前1条弹窗广告（每天对同一个用户只展示1次，关闭弹窗广告请删除）" placement="top">  <el-radio label="8">首页弹窗广告
                          <p style="font-size:11px;">(750*1000px)</p>
                        </el-radio>  </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="本地资讯发布不限，展示所有已上架的资讯" placement="top">  <el-radio label="6">本地资讯
                          <p style="font-size:11px;">(750*480px)</p>
                        </el-radio></el-tooltip>

                      </el-radio-group>

                </el-form-item>

                <el-form-item label="标题" label-position="left" prop="title">
                    <el-input placeholder="输入简要标题（建议30字以内）" v-model="bannerForm.title">
                    </el-input>
                </el-form-item>

                <el-form-item label="展示渠道" label-position="left" v-if="loginInfo.loginPath=='cxh'">
                    <el-select :change="selectControoler()" filterable multiple placeholder="请选择展示渠道（不选为默认展示全国渠道）"
                               style="width:800px;" v-model="bannerForm.channelId">
                        <el-option :label="item.label+''" :value="item.value+''" v-for="item in channelOptions">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="封面图片" label-position="top" prop="coverImgURL">
                    <el-upload :action="baseUrl+'upload/uploadPic'" :data="{floder:'news'}" :show-file-list="false"
                               accept="image/*" class="avatar-uploader" v-model="bannerForm.coverImgURL">
                        <img :src="bannerForm.coverImgURL.url" class="avatar" v-if="bannerForm.coverImgURL">
                        <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                    </el-upload>
                </el-form-item>

                <el-form-item label="链接" label-position="left" prop="link">
                    <el-input placeholder="请输入链接" v-model="bannerForm.link">
                    </el-input>
                </el-form-item>

                <el-form-item class="basic-margin">
                    <el-button type="primary">保存</el-button>
                    <el-button @click="back()">取消</el-button>
                </el-form-item>
            </el-col>
        </el-form>

    </el-row>

</template>

<script>

import ChannelModel from '@/framework/models/channelModel'
import NewsModel from '@/framework/models/newsModel'
import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'

export default {
  name: 'add-thematic-dialog',
  extends: BasicPager,
  data: function () {
    return {
      checkAll: false,
      visible: false,
      imageUrl: '',
      baseUrl: Config.baseUrl,
      baseImageUrl: Config.imageUrl,
      targetDbtResult: 1,
      channelOptions: [],
      bannerForm: {
        id: null,
        type: 2,
        link: '',
        title: '',
        target: null,
        channelId: [],
        coverImgURL: null,
        createType: null,
        createPerson: null,
        channelKey: null
      },
      rules: {
        title: [{
          required: true,
          message: '标题不能为空',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度在 1 到 50 个字符',
          trigger: 'blur'
        }],
        target: [{
          required: true,
          message: '请选择广告位类型',
          trigger: 'blur'
        }],
        channelId: [{
          type: 'array',
          required: true,
          message: '请选择一个渠道',
          trigger: 'change'
        }],
        coverImgURL: [{
          required: true,
          message: '请上传封面图片',
          trigger: 'change'
        }]
      }
    }
  },
  created: function () {
    // 获取参数
    let params = this.$route.params
    if (params) {
      this.bannerForm.id = params.id
    }

    let loginInfo = this.loginInfo
    this.bannerForm.channelId = loginInfo.loginPath == 'cxh' ? this.bannerForm.channelId : [loginInfo.id]
    this.bannerForm.createType = loginInfo.loginPath == 'cxh' ? 1 : 2,
    this.bannerForm.createPerson = loginInfo.realName
    let roleName = loginInfo.roleName

    switch (roleName) {
      case '汽车网渠道':
        this.targetDbtResult = 1
        break
      case '社群渠道':
      case '加油渠道(单企版)':
      case '加油渠道(平台版)':
      case '二手车+加油渠道(单企版)':
      case '二手车+加油渠道(平台版)':
      case '二手车渠道':
        this.targetDbtResult = 2
        break
      case '汽车网+加油渠道(单企版)':
      case '汽车网+加油渠道(平台版)':

        this.targetDbtResult = 3
        break
    }
    this.loadChannelList()
  },
  methods: {

    onFilterParams: function (params) {
      params.channelKey = this.bannerForm.channelId.join(',')
    },
    selectControoler: function () {
      let _this = this
      let temp = []
      let channelstr = this.bannerForm.channelId.toString()
      if (channelstr.indexOf(-1) > -1) {
        for (var item of _this.channelOptions) {
          if (item.value == -1) {
            continue
          }
          temp.unshift(item.value)
        }

        this.bannerForm.channelId = temp
      }
    },
    loadChannelList: function () {
      let _this = this
      let listener = {
        success: function (dataInfo) {
          _this.channelOptions = dataInfo.datas
        }
      }
      ChannelModel.findChannelSelectOption(this, listener)
    },
    submitForm: function () {
      let _this = this
      let loginInfo = _this.loginInfo
      _this.bannerForm.channelId = loginInfo.loginPath == 'cxh' ? _this.bannerForm.channelId : [loginInfo.id]
      let params = {
        channelKey: _this.bannerForm.channelId.join(','),
        title: _this.bannerForm.title,
        coverImg: _this.imageUrl,

        link: _this.bannerForm.link,
        type: _this.bannerForm.type,
        target: 1,
        createType: loginInfo.loginPath == 'cxh' ? 1 : 2,
        createPerson: loginInfo.realName
      }

      let listener = {
        success: function (dataInfo) {
          _this.visible = false
          _this.$emit('handleAddSuccess', dataInfo)
          _this.$message({
            message: '添加成功',
            type: 'success'
          })
          $router.push({ path: '/home/thematicManagement' })
        }
      }
      NewsModel.addNews(this, params, listener)
    },
    back: function () {
      this.$router.back(-1)
    }
  }
}

</script>
